import { ActionReducerMap } from "@ngrx/store";

import { fetchStatusReducer } from "./src/fetch-status/fetch-status.reducer";
import { NgrxUtilsState } from "./src/model";
import { stateCacheReducer } from "./src/state-cache/state-cache.reducer";

export { FetchStatusType } from "./src/fetch-status/fetch-status.model";
export { fetchStatusReducer } from "./src/fetch-status/fetch-status.reducer";
export { FetchStatusSelector } from "./src/fetch-status/fetch-status.selector";
export { SYNC_SUFFIX } from "./src/fetch-status/fetch-status.const";

export { stateTransfer } from "./src/state-transfer/state-transfer";
export { StateTransferEffect } from "./src/state-transfer/state-transfer.effect";

export { RehydrateAction, REHYDRATE_ACTION_TYPE } from "./src/rehydrate/rehydrate.action";
export { rehydrate } from "./src/rehydrate/rehydrate.reducer";
export { RehydrateOptions, RehydrateState } from "./src/rehydrate/rehydrate.model";

export { STORE_CACHE_TYPE, StateCacheAction } from "./src/state-cache/state-cache.action";
export { StateCacheEffect } from "./src/state-cache/state-cache.effect";
export {
	StateCacheStrategy,
	GetActionCached,
	StateCacheState,
	StateCacheOptions,
	CacheType,
	CacheDetail,
} from "./src/state-cache/state-cache.model";
export { StateCacheSelector } from "./src/state-cache/state-cache.selector";
export {
	createCachedGetAction,
	createGetSuccessAction,
	getCacheKey,
	isCachedGet,
	isCachedGetSuccess,
	restoreOriginalAction,
} from "./src/state-cache/state-cache.util";
export { batchActions, enableBatching, BATCH_ACTION_TYPE } from "./src/extensions/actions-batcher";

export { NgrxUtilsModule, _ngrxUtilsConfigFactory, _initializeStateTransfer } from "./src/module";
export { NGRX_UTILS_CONFIG } from "./src/const";
export { ActionWithPayload, NgrxUtilsConfig, NgrxUtilsState } from "./src/model";

export const NGRX_UTILS_REDUCER: ActionReducerMap<NgrxUtilsState> = {
	fetchStatus: fetchStatusReducer,
	stateCache: stateCacheReducer,
};
